import Vue from 'vue';
import Vuex from 'vuex';
import globalValues from '@/store/registration/modules/globalValues';
import registration from '@/store/registration/modules/registration';
import navigation from '@/store/registration/modules/navigation';
import utils from '@/store/registration/modules/utils';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    globalValues,
    registration,
    navigation,
    utils
  }
});

export default store;
